import { getAssessmentResult, getUserInfo } from "@/lib/freeAssessment";
import { calculateGrade } from "@/lib/utils";
import { format } from "date-fns";
import * as htmlToImage from "html-to-image";
import { jsPDF } from "jspdf";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import Heading from "./_components/Heading";

function FreeCertificatePage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const info = getUserInfo();
  if (!info) {
    navigate("/free-assessment/info");
    return null;
  }
  const result = getAssessmentResult();
  if (!result) {
    navigate("/free-assessment/questions");
    return null;
  }

  const handleDownload = () => {
    const ele = document.getElementById("free-certificate");
    if (!ele) return;
    htmlToImage
      .toPng(ele, { quality: 1.0, pixelRatio: 3 })
      .then(function (dataUrl) {
        // const width = 595;
        // const height = 842;
        // var link = document.createElement('a');
        // link.download = 'my-image-name.jpeg';
        // link.href = dataUrl;
        // link.click();
        const docs = new jsPDF({
          // format: [595, 842],
          // unit: "px",
          orientation: "portrait",
          format: "a4",
        });
        const width = docs.internal.pageSize.width;
        const height = docs.internal.pageSize.height;
        docs.addImage(
          dataUrl,
          "PNG",
          0,
          0,
          width,
          height,
          "free-certificate",
          "FAST",
        );
        docs.save("certificate-of-completion.pdf");
      });
  };

  return (
    <div>
      <Heading handleDownload={handleDownload} />
      <div className="mx-auto my-8 w-[595px] flex justify-center">
        <div className="relative w-max" id="free-certificate">
          <img src={"/images/free-super-large.svg"} alt={"free-bg"} />
          <p className="text-[20px] leading-[30px] text-[#00193F] font-[600] absolute top-[265px] left-[50%] translate-x-[-50%]">
            {info.companyName}
          </p>
          <p className="text-[12px] leading-[18px] text-[#00193F] font-[600] absolute top-[310px] left-[50%] translate-x-[-50%]">
            {info.lastName} {info.firstName} 殿
          </p>
          <p className="text-[48px] leading-[72px] text-[#005B85] absolute top-[450px] left-[50%] translate-x-[-50%] font-semibold">
            {calculateGrade(result.total)}
          </p>
          <p className="text-[12px] leading-[18px] text-[#00193F] absolute bottom-[140px] right-[21.5%] translate-x-[-50%] font-semibold">
            {format(new Date(), t("date-format"))}
          </p>
        </div>
      </div>
    </div>
  );
}

export default FreeCertificatePage;
